import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getMessage } from '@tcc/i18n';

import { setActiveSubLayer } from '../../../actions/layersActions';

import Card from '../../../components/cards/cardAndPreview/Card';

import {
  hasHistoricWeatherSelector,
  latestFHAEvent,
} from '../../../selectors/fhaSelectors';
import { gduListSelector, gduValueForFHAEvent } from '../../../selectors/weatherSelector';
import { getFeatureValue } from '../../../selectors/featureSelectors';
import { switchLayer } from '../../../utils/url';
import { toDateString } from '../../../utils/date';
import { trackEvent } from '../../../actions/analyticsActions';
import { getCurrentSeason } from '../../../selectors';

import { FHA, FHA_KEY } from '../../../constants/mapLayerIds';
import { MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE } from '../../../constants/featureFlags';
import fhaStyles from './FHACard.css';
import styles from '../../../components/cards/cardAndPreview/cardAndPreview.css';

export class FHACard extends Component {
  onClickViewAll = (e) => {
    e.preventDefault();
    const { index, trackAnalyticsEvent } = this.props;
    switchLayer(index, FHA_KEY);

    trackAnalyticsEvent('field_health_context_card', 'viewed');
  };

  onImageClick = (e) => {
    const {
      index,
      season,
      event,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    const layer = e.currentTarget.id;
    const activeSubLayer = {
      date: event.date,
      segmentSelected: layer,
      layer,
    };
    setActiveSubLayerProp(FHA_KEY, activeSubLayer, index, season);
    switchLayer(index, FHA_KEY);
  };

  getTable = () => {
    const { event, hasHistoricWeather, microsoftGDDGlobalRelease, locale, gdu } = this.props;
    const { thumbnailUri: vegetationThumbnail } = event[FHA.VEGETATION];
    const { thumbnailUri: scoutingThumbnail } = event[FHA.SCOUTING];
    const time = toDateString(event.date, locale);

    return (
      <table className={fhaStyles.table}>
        <tbody>
          <tr>
            <td className={styles.value} data-test-id="FHA-context-card-time">
              {time}
            </td>
            {(microsoftGDDGlobalRelease || hasHistoricWeather) && (
              <td
                className={styles.value}
                data-test-id="FHA-context-card-GDUs-value"
              >
                {gdu}
              </td>
            )}
          </tr>
          <tr>
            <td>
              <h3 data-test-id="FHA-context-card-latest-image-label">
                {getMessage('card.fha.latestImage')}
              </h3>
            </td>
            {(microsoftGDDGlobalRelease || hasHistoricWeather) && (
              <td>
                <h3 data-test-id="FHA-context-card-gdus-label">
                  {getMessage('card.fha.gdus')}
                </h3>
              </td>
            )}
          </tr>
          <tr>
            <td>
              <img
                alt={getMessage('image.vegetation.card')}
                className={styles.clickable}
                data-test-id="FHA-context-card-vegetation-image"
                id={FHA.VEGETATION}
                onClick={this.onImageClick}
                src={vegetationThumbnail}
              />
            </td>
            <td>
              <img
                alt={getMessage('image.scouting.card')}
                className={styles.clickable}
                data-test-id="FHA-context-card-scouting-image"
                id={FHA.SCOUTING}
                onClick={this.onImageClick}
                src={scoutingThumbnail}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    const { event } = this.props;
    const link = event ? getMessage('viewAll') : null;
    return (
      <Card
        cardType="fha"
        errorMessage={!event ? getMessage('card.fha.noData') : ''}
        key="fha-link-card"
        link={link}
        onClickLink={this.onClickViewAll}
        title={getMessage('card.fha')}
      >
        {event && this.getTable()}
      </Card>
    );
  }
}

FHACard.propTypes = {
  event: PropTypes.object,
  hasHistoricWeather: PropTypes.bool.isRequired,
  index: PropTypes.number,
  locale: PropTypes.string,
  season: PropTypes.string,
  setActiveSubLayer: PropTypes.func.isRequired,
  trackAnalyticsEvent: PropTypes.func.isRequired,
};

export function mapStateToProps(state, props) {
  const season = getCurrentSeason(state, props);
  const event = latestFHAEvent(state, props);
  const gdu = event ? gduValueForFHAEvent(gduListSelector(state, props), event) : null;

  return {
    hasHistoricWeather: hasHistoricWeatherSelector(state),
    microsoftGDDGlobalRelease: getFeatureValue(state, { key: MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE }),
    locale: state.app.locale,
    event,
    gdu,
    season,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        setActiveSubLayer,
        trackAnalyticsEvent: trackEvent,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FHACard);
